'use client';

import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-center"
      style={{
        top: '80px',
      }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-bg-elevated group-[.toaster]:text-semantic-label-strong group-[.toaster]:border-line-solid-normal group-[.toaster]:shadow-card',
          description: 'group-[.toast]:text-semantic-label-normal',
          actionButton:
            'group-[.toast]:bg-semantic-inverse-background group-[.toast]:text-semantic-inverse-label',
          cancelButton: 'group-[.toast]:bg-fill-normal group-[.toast]:text-semantic-label-normal',
          error:
            'group-[.toaster]:bg-atomic-red-25 group-[.toaster]:text-semantic-status-destructive group-[.toaster]:border-semantic-status-destructive',
        },
      }}
      duration={5000}
      {...props}
    />
  );
};

export { Toaster };
